const getFileExtension = (string) => {
  const dotIndex = string.lastIndexOf('.');

  if (dotIndex < 0 || dotIndex === string.length) return false;

  return string.substring(dotIndex + 1);
};

export default getFileExtension;
